import { render, staticRenderFns } from "./PatientTests.vue?vue&type=template&id=337d8a24&scoped=true"
import script from "./PatientTests.vue?vue&type=script&lang=js"
export * from "./PatientTests.vue?vue&type=script&lang=js"
import style0 from "./PatientTests.vue?vue&type=style&index=0&id=337d8a24&prod&scoped=true&lang=css"
import style1 from "./PatientTests.vue?vue&type=style&index=1&id=337d8a24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337d8a24",
  null
  
)

export default component.exports